import React, { useContext, useState } from "react";
import AccordionSection from "../../../components/AccordionSection";
import { UserSettingsCollapseKeys } from "../../../types/User";
import { IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import _ from "lodash";
import AppLink from "../../../components/common/AppLink/AppLink";
import { ROUTE_PATHS } from "../../../routes/Routes";
import { DisableContext } from "../../../contexts/DisableContextProvider";
import ResponsiveButton from "../../../uikit/buttons/ResponsiveButton";
import { EventTemplateParentChild } from "../../../types/EventTemplate";
import { EditEventTemplateChildModal } from "./EditEventTemplateChildModal";

interface IEventTemplatesSectionProps {
  eventTemplateChildren: EventTemplateParentChild[];
  setEventTemplateChildren: (children: EventTemplateParentChild[]) => void;
}

const NEW_MODAL_CHILD: EventTemplateParentChild = {
  uuid: 'new',
  child_uuid: '',
  child_name: '',
  offset: NaN,
  new_record: true,
};

export default function EventTemplatesSection({ eventTemplateChildren, setEventTemplateChildren }: IEventTemplatesSectionProps) {
  const { disabled } = useContext(DisableContext);
  const [modalChild, setModalChild] = useState<EventTemplateParentChild | null>(null);

  const handleRemoveChild = (uuid: string) => setEventTemplateChildren(_.reject(eventTemplateChildren, { uuid }));
  const handleSubmit = () => {
    if (modalChild === null) return;

    if (modalChild.uuid === NEW_MODAL_CHILD.uuid) {
      setEventTemplateChildren([...eventTemplateChildren, { ...modalChild, uuid: crypto.randomUUID() }]);
    } else {
      setEventTemplateChildren(_.map(eventTemplateChildren, child => (child.uuid === modalChild.uuid ? modalChild : child)));
    }
    setModalChild(null);
  };

  const headerButton = (
    <ResponsiveButton startIcon={<AddIcon />} variant="outlined" onClick={() => setModalChild(NEW_MODAL_CHILD)} disabled={disabled}>
      Add
    </ResponsiveButton>
  );

  return (
    <>
      <AccordionSection title="Subevent Templates" headerElements={headerButton} collapseId={UserSettingsCollapseKeys.EVENT_TEMPLATE_CHILDREN_TEMPLATES}>
        <Table sx={{ mx: 1, mt: 1 }}>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Start Offset</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              _.map(_.sortBy(eventTemplateChildren, 'offset'), child => (
                <TableRow key={child.uuid}>
                  <TableCell><AppLink to={`/${ROUTE_PATHS.EVENT_TEMPLATES}/${child.child_uuid}`}>{child.child_name}</AppLink></TableCell>
                  <TableCell>{child.offset}</TableCell>
                  <TableCell>
                    {!disabled && (
                      <>
                        <IconButton onClick={() => setModalChild(child)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleRemoveChild(child.uuid)}>
                          <DeleteIcon />
                        </IconButton>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))
            }
          </TableBody>
        </Table>
      </AccordionSection>

      <EditEventTemplateChildModal
        open={!!modalChild}
        onClose={() => setModalChild(null)}
        onSubmit={handleSubmit}
        eventTemplateChild={modalChild || NEW_MODAL_CHILD}
        setEventTemplateChild={setModalChild}
      />
    </>
  );
}
